(function($) {
  var anchorNavigationItems, awardsList, awardsListControls, header, map, menuOverlay, menuOverlayCloseButton, menuOverlayOpenButton, scrollIndicators, tagControls, tagList;
  // NoJs Fallback
  $('.nojs').removeClass('nojs');
  // Header Animation
  header = $('header .banner');
  setTimeout(function() {
    return header.addClass('fadedIn');
  }, 3000);
  // Overlay Menu
  menuOverlay = $('.main-navigation');
  menuOverlayOpenButton = $('.open-menu');
  menuOverlayCloseButton = $('.close-menu');
  menuOverlayOpenButton.on('click', function(e) {
    e.preventDefault();
    return menuOverlay.addClass('open');
  });
  menuOverlayCloseButton.on('click', function(e) {
    e.preventDefault();
    return menuOverlay.removeClass('open');
  });
  // Anchor Navigation
  anchorNavigationItems = $('.anchor-navigation a:not(.logo), .sticky-navigation a:not(.logo)');
  anchorNavigationItems.on('click', function(e) {
    var targetElement;
    e.preventDefault();
    targetElement = $($(this).attr('href'));
    return $('html, body').animate({
      scrollTop: targetElement.offset().top - 70
    }, 800);
  });
  // Sticky Anchor Navigation
  $('.sticky-navigation').headroom({
    // offset: $('header + section').offset().top + $('.anchor-navigation').height()
    offset: 200
  });
  // Awards List Expand Controls
  awardsList = $('.module-awards .awards-list');
  awardsListControls = $('.module-awards .awards-list-controls button');
  awardsListControls.on('click', function(e) {
    e.preventDefault();
    awardsList.toggleClass('expanded');
    if ($(this).text() === $(this).data('label-more')) {
      return $(this).text($(this).data('label-less')).attr('class', 'awards-list-control-minus');
    } else {
      return $(this).text($(this).data('label-more')).attr('class', 'awards-list-control-plus');
    }
  });
  // Tag Expand Controls
  tagList = $('.module-tags ul');
  tagControls = $('.module-tags .tag-controls button');
  tagControls.on('click', function(e) {
    e.preventDefault();
    tagList.toggleClass('expanded');
    if ($(this).text() === $(this).data('label-more')) {
      return $(this).text($(this).data('label-less')).attr('class', 'tag-controls-minus');
    } else {
      return $(this).text($(this).data('label-more')).attr('class', 'tag-controls-plus');
    }
  });
  // Production Sliders
  $('.module-productions .slider-regular .slider-slides').slick({
    dots: true,
    prevArrow: $('.module-productions .slider-regular .slider-controls .prev'),
    nextArrow: $('.module-productions .slider-regular .slider-controls .next'),
    appendDots: $('.module-productions .slider-regular .slider-controls .dots')
  });
  $('.module-productions .slider-mobile .slider-slides').slick({
    dots: true,
    prevArrow: $('.module-productions .slider-mobile .slider-controls .prev'),
    nextArrow: $('.module-productions .slider-mobile .slider-controls .next'),
    appendDots: $('.module-productions .slider-mobile .slider-controls .dots'),
    rows: 2
  });
  // Scroll Down if Filter or Pagination Used
  scrollIndicators = $('[data-scrolldown]');
  if (scrollIndicators.length > 0) {
    $('html, body').animate({
      scrollTop: $(scrollIndicators[0]).offset().top - 70
    }, 800);
  }
  // Press Slider
  $('.module-press .slider-slides').slick({
    dots: true,
    prevArrow: $('.module-press .slider-controls .prev'),
    nextArrow: $('.module-press .slider-controls .next'),
    appendDots: $('.module-press .slider-controls .dots')
  });
  // About Us Slider
  $('.module-about .slider-slides, .single-block-gallery .slider-slides').slick({
    arrows: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1
        }
      }
    ]
  });
  // Video Lightboxes
  $('[data-fancybox="video"]').fancybox({
    closeExisting: true,
    loop: true,
    infobar: false,
    buttons: ['close']
  });
  // Image Lightboxes
  $('[data-fancybox="image"]').fancybox({
    closeExisting: true,
    loop: true,
    infobar: false,
    buttons: ['close']
  });
  // Contact Page Map
  // Google Map Options: https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
  map = $('.map');
  if (map.length > 0) {
    map.gmap3({
      center: [53.584391, 10.126754],
      zoom: 18,
      mapTypeControl: false,
      navigationControl: false,
      scrollwheel: false,
      streetViewControl: false,
      fullscreenControl: false
    }).marker([
      {
        position: [53.584351,
      10.126754],
        icon: "/wp-content/themes/letterbox/assets/img/icon-pin.svg"
      }
    ]);
  }
  // Hashtag Filter by Year
  return $('#filter-by-year, #filter-by-category, #production-format, #production-genre').selectric({
    nativeOnMobile: false
  }).on('selectric-change', function(event, element, selectric) {
    return $(element).closest('form').trigger('submit');
  });
})(jQuery);

//# sourceMappingURL=script.js.map
